<template>
  <div v-if="showBandenLabelToolButton">
    <app-button
      data-qa="banden-bale-tool-button"
      class="quoteActionsButton"
      @click="openBandenLabelTool"
    >
      {{ i18n.t('/QuoteActions/BandenLabelToolText') }}
    </app-button>
  </div>
</template>

<script>
import AppButton from '@/components/generic/presentational/atoms/appButton/AppButton.vue'
import moment from 'moment/moment'
import { mapGetters } from 'vuex'

export default {
  components: {
    AppButton,
  },
  data() {
    return {
      i18n: window.VUE_CLI_EXPORTS.plugins.i18n,
    }
  },
  computed: {
    ...mapGetters({
      configuration: 'configuration/configuration',
    }),
    showBandenLabelToolButton() {
      return this.i18n.translationExists('/QuoteActions/BandenLabelToolUrl')
    },
  },
  methods: {
    openBandenLabelTool() {
      let referenceDate = moment.utc().format('DD-MM-YYYY')
      let url = this.i18n.t('/QuoteActions/BandenLabelToolUrl', {
        modelKey: this.configuration?.ModelKey,
        modelYear: this.configuration?.ModelYear,
        referenceDate: referenceDate,
      })

      window.open(url)
    },
  },
}
</script>

<style lang="scss" scoped></style>
